import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbMenuBag, NbMenuService } from '@nebular/theme';
import { MenuItemContext, RendererType, Section } from '../../../../editor-container/editor-model';
import { ContentElement, ContentEnum, ContentStatusEnum, GridCell, RowCell } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../../../sections-editor/shared-section-builder/section-builder-store.service';
import { BehaviorSubject } from 'rxjs';

export enum EditMode{
  CONTENTELEMENT = "contentElement",
  SECTION = "section",
  CELL = "cell"
}

@Component({
  selector: 'kve-editor-template-options',
  templateUrl: './editor-template-options.component.html',
  styleUrls: ['./editor-template-options.component.scss']
})
export class EditorTemplateOptionsComponent implements OnChanges{
  @Input() section:Section;
  @Input() rendererType:RendererType;
  @Input() orientation:string;
  @Input() status:ContentStatusEnum;
  //status:ContentStatusEnum;
  contentEnum:ContentEnum;
  menuBag:NbMenuBag;

  context:string;

  //trackStatus$ = new BehaviorSubject(ContentStatusEnum.CTNT_IN_PROGRESS);

  readonly RendererType = RendererType;

  title:string;

  currentEditMode:EditMode;

  readonly EditMode = EditMode;

  readonly ContentEnum:ContentEnum;

  contentEnumValue:string;

  selectedContentElement:ContentElement;
  selectedCell:GridCell | RowCell;
  cellId:string;


 

  constructor(
    private menuService:NbMenuService,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private cd: ChangeDetectorRef) { 
      this.menuService.onItemClick().subscribe((menuBag) => {
        this.getEditContext(menuBag)
      })
    }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["status"]){
      if(this.status != undefined){
        //if (status !== this.status) {
          //this.cd.markForCheck();
          //this.status = status;
          //this.trackStatus$.next(this.status);
          console.log(this.status);
          if(this.section != undefined){
            console.log(this.section );
            this.rendererType = this.section.rendererType;
            this.contentEnum = this.resolveFirstContentEnum(this.section);
            /* if(this.selectedCell != undefined){
              this.resolveSelectedCell(this.section);
            } */
            console.log(this.contentEnum);                    
          }
        //}
      }else{
        if(this.section != undefined){
          console.log(this.section)
          if(this.section && this.section.rendererType){
            this.rendererType = this.section.rendererType;
            console.log(this.section.rendererType)
            this.contentEnum = this.resolveFirstContentEnum(this.section);
            /* if(this.selectedCell == undefined){
              this.resolveSelectedCell(this.section);
            } */
          }
        }
      }
      
    }
    /* this.status$.subscribe((status) => {
      if(status != undefined){
        if (status !== this.status) {
          this.cd.markForCheck();
          this.status = status;
          this.trackStatus$.next(this.status);
          console.log(status);
          if(this.section != undefined){
            console.log(this.section );
            this.rendererType = this.section.rendererType;
            this.contentEnum = this.resolveFirstContentEnum(this.section);
          }
        }
      }else{
        if(this.section != undefined){
          console.log(this.section)
          if(this.section && this.section.rendererType){
            this.rendererType = this.section.rendererType;
            console.log(this.section.rendererType)
            this.contentEnum = this.resolveFirstContentEnum(this.section);
          }
        }
      }
    }); */
  }


  getEditContext(menuBag:NbMenuBag):void{
    this.menuBag = menuBag;
    if(menuBag.tag === "inputMenu"){
      console.log(menuBag)
      let context:MenuItemContext = menuBag.item.data;
      if(context.contentElement != undefined){
        if(this.contentEnum == undefined){
          this.contentEnum = context.cell.contentEnum;
        }
        console.log("rendererType",this.rendererType,"contentEnum",this.contentEnum,"selectedCell",this.selectedCell)
        this.selectedContentElement = context.contentElement;
        this.sectionBuilderStoreService.updateContent(this.selectedContentElement);

        this.currentEditMode = EditMode.CONTENTELEMENT
      }else if(context.cellId != undefined){
        this.selectedCell = context.cell;
        if(this.contentEnum == undefined){
          this.contentEnum = context.cell.contentEnum;
        }
        this.sectionBuilderStoreService.updateSelectedCell(this.selectedCell);
        console.log("Set mode to cell",this.contentEnum)
        this.currentEditMode = EditMode.CELL        
      }
    }else if(menuBag.tag === "sectionEditorMenu"){
      console.log("sectionEditorMenu",menuBag);
      this.currentEditMode = EditMode.SECTION;
      this.title = menuBag.item.title;      
    }else if(menuBag.tag === "editorSelector"){
      console.log(menuBag);
      this.currentEditMode = EditMode.CONTENTELEMENT
    }
    

    //let sectionEditContext = menuBag.item?.data?.context?menuBag.item.data.context:null;
    //this.context = sectionEditContext;
    
    /* if(sectionEditContext != null ){
      this.context = sectionEditContext;
      console.log(this.context)
    } */
  }
  /**
   * 
   * @param section The Section object for the section to be edited
   * Determines the contentEnum for the first cell in the section and sets it.
   * 
   */
  resolveFirstContentEnum(section:Section):ContentEnum{
    let options:any;
    let cells:any[] = [];
    let contentEnum;
    switch (this.getEnumValue(section.rendererType)) {
      case "grid":
      case RendererType.GRID:
        options = section.sectionData.gridOptions 
        cells = options.gridCells;
        contentEnum = cells[0].contentEnum?cells[0].contentEnum:ContentEnum.BANNER;
        if(this.selectedCell == undefined){
          this.selectedCell = cells[0];
          this.cellId = this.selectedCell.cellId
        }
        break;
      case "row":
      case RendererType.ROW:
        options = section.sectionData.rowOptions;
        cells = options.rowCells;
        break;  
      case "banner":
      case RendererType.BANNER:
        options = section.sectionData.bannerOptions;
        this.contentEnum = ContentEnum.BANNER; 
        break;
      case "bloglist":
      case RendererType.BLOGLIST:
        options = section.sectionData.blogListOptions
        break;
      case "news-letter-sign-up":
      case RendererType.NEWSLETTER:
        options = section.sectionData.bannerOptions 
        break;
      case "store-features":
      case RendererType.STOREFEATURES:
        options = section.sectionData.gridOptions 
        break;
      case "slider":
      case RendererType.SLIDER:
        options = section.sectionData.gridOptions 
        break;
      case "rich-text":
      case RendererType.RICH_TEXT:
        options = section.sectionData.gridOptions 
        break;
      case "testimonials":
      case RendererType.TESTIMONIALS:
        options = section.sectionData.gridOptions 
        break;
      case "category":
      case RendererType.CATEGORY:
        options = section.sectionData.gridOptions 
        break;
      case "product":
      case RendererType.PRODUCT:
        options = section.sectionData.gridOptions 
        break;
      case "cart":
      case RendererType.CART:
        options = section.sectionData.gridOptions 
        break;
      case "blog":
      case RendererType.BLOG:
        options = section.sectionData.gridOptions 
        break;
      case "hero-image":
      case RendererType.HEROIMAGE:
        cells = section.sectionData.gridOptions.gridCells;
        contentEnum = cells[0].contentEnum?cells[0].contentEnum:ContentEnum.HERO_IMAGE;
        if(this.selectedCell == undefined){
          this.selectedCell = cells[0];
          this.cellId = this.selectedCell.cellId
        }
        //console.log(options) 
        break;

      default:
        console.log("Not able to resolve rendererType for "+section.rendererType)
        break;
    }
    return contentEnum;
  }

  getEnumValue(renTypeEnum:RendererType){
    let enumValue:string;
    if(renTypeEnum != undefined){
      if((renTypeEnum).includes(".")){
        let enumKey = renTypeEnum.split('.')[1] as keyof typeof RendererType;
        enumValue = RendererType[enumKey];
      }else if(RendererType[renTypeEnum] != undefined){
        enumValue = RendererType[renTypeEnum]
      }else{
        enumValue = renTypeEnum;
      }
    }
    //console.log(enumValue)
    
    return enumValue;
  }

  resolveSelectedCell(section:Section):GridCell|RowCell{

    return
  }

}
